import { Amount, Consent, Transaction } from '~/types';
import axios, { ResponseType } from './axios';

export interface OatConsentRequest {
  senderAccountId: string;
  recipientAccountId: string;
  localUTCOffset?: string;
  amount: Amount;
  comment?: string;
}

export const createOatConsent = (body: OatConsentRequest): ResponseType<Consent[]> => {
  return axios.post('/ownAccountsTransfer/consent', body);
};

export const updateOatConsent = (
  consentId: string,
  body: OatConsentRequest
): ResponseType<Consent[]> => {
  return axios.put(`/ownAccountsTransfer/consent/${consentId}`, body);
};

export const makeOatTransfer = (consentId: string): ResponseType<Transaction[]> => {
  return axios.post(`/ownAccountsTransfer`, { consentId });
};
